import { useCallback, useEffect, useState } from 'react';
import { store } from 'redux/store';

import { Document } from 'types';
import { getOperationDocuments } from '../api/getOperationDocuments';

type UseGetOperationDocumentsProps = {
  operationId: string | undefined;
};

export const useGetOperationDocuments = ({
  operationId,
}: UseGetOperationDocumentsProps) => {
  const [documents, setDocuments] = useState<Document[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchDocuments = useCallback(async () => {
    try {
      setIsLoading(true);

      if (operationId) {
        const documents = await store.dispatch(
          getOperationDocuments({ operationId })
        );
        setDocuments(documents);
      } else {
        setDocuments([]);
      }

      setIsLoading(false);
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
    }
  }, [operationId]);

  useEffect(() => {
    fetchDocuments();
  }, [fetchDocuments]);

  return {
    data: { documents },
    isLoading,
    isError,
    actions: {
      fetchDocuments,
    },
  };
};
